export function checkProductsInBasket( products, basket ) {

    if ( products || basket.fetched ) {
        return products.map( ( product ) => {
            const _product = { ...product };
            _product.in_basket = basket.products.filter( ( _product ) => product.id === _product.id ).length > 0;
            return _product;
        } );
    }

}

export function checkPackagesInBasket( packages, basket ) {

    if ( packages || basket.fetched ) {
        return packages.map( ( item ) => {
            const _packageItem = { ...item };
            _packageItem.in_basket = basket.packages.filter( ( _item ) => item.id === _item.id ).length > 0;
            return _packageItem;
        } );
    }

}


// WEBPACK FOOTER //
// src/client/helpers/BasketCheckHelper.js